import { Component, Input } from '@angular/core';
import { ZoningCode } from 'src/app/modules/instance/models';
import { ZoningCodeService } from 'src/app/modules/instance/services';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    standalone: false,
    selector: 'app-zoning-code-check-version-button',
    templateUrl: './zoning-code-check-version-button.component.html',
    styleUrls: ['./zoning-code-check-version-button.component.scss']
})
export class zoningCodeCheckVersionButtonComponent {
    constructor(private readonly zoningCodeService: ZoningCodeService,
        private readonly snackBar: MatSnackBar,

    ) { }

    @Input()
    public zoningCode: ZoningCode;

    public checkVersion(event: Event, zoningCode: ZoningCode) {
        if (!zoningCode.hasVersionsTasks) {
            this.zoningCodeService.checkZoningCodeVersion(zoningCode);
        } else {
            this.snackBar.open(`To check for a new version of Zoning Code, delete the existing calculation process.
                Note: after registering a new version, the calculation of the current version will not be possible.`, 'OK', {
                verticalPosition: 'top',
                horizontalPosition: 'center',
                duration: 6000
            });
        }

        event.stopPropagation();
    }

}
